import { MapTilerBaseLayerBase } from "./MapTilerBaseLayerBase";
export class LightGreyMapLayer extends MapTilerBaseLayerBase {
    constructor() {
        super(LightGreyMapLayer.Url);
    }
    onAfterFetch(style) {
        // update oneway arrows.
        MapTilerBaseLayerBase.removeLayers(style, ["road_oneway", "road_oneway_opposite"]);
        MapTilerBaseLayerBase.addLayer(style, {
            id: "road-oneway",
            type: "symbol",
            source: "openmaptiles",
            "source-layer": "transportation",
            minzoom: 15,
            "layout": {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                /* @ts-ignore */
                "icon-size": {
                    "stops": [
                        [
                            15,
                            0.5
                        ],
                        [
                            19,
                            1
                        ]
                    ]
                },
                "text-font": [],
                "icon-image": "oneway",
                "icon-rotate": 90,
                "icon-padding": 2,
                "symbol-spacing": 75,
                "symbol-placement": "line",
                "icon-rotation-alignment": "map"
            },
            "paint": {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                /* @ts-ignore */
                "icon-opacity": 0.5
            },
            filter: MapTilerBaseLayerBase.IsOnewayFilter()
        }, "highway-name-path");
        MapTilerBaseLayerBase.addLayer(style, {
            id: "road-oneway-reverse",
            type: "symbol",
            source: "openmaptiles",
            "source-layer": "transportation",
            minzoom: 15,
            paint: {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                /* @ts-ignore */
                "icon-opacity": 0.5
            },
            layout: {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                /* @ts-ignore */
                "icon-size": {
                    "stops": [
                        [
                            15,
                            0.5
                        ],
                        [
                            19,
                            1
                        ]
                    ]
                },
                "text-font": [],
                "icon-image": "oneway",
                "icon-rotate": -90,
                "icon-padding": 2,
                "symbol-spacing": 75,
                "symbol-placement": "line",
                "icon-rotation-alignment": "map"
            },
            filter: MapTilerBaseLayerBase.IsOnewayReverseFilter()
        }, "road-oneway");
    }
}
LightGreyMapLayer.Url = "https://api.maptiler.com/maps/ac34234e-5ce7-4a0f-95e2-0632b493fda1/style.json?key=OZUCIh4RNx38vXF8gF4H";
